import { Grid } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { municipalityApiKeyStore } from '../../../../api/masters/municipality-api-key-store';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';

interface MunicipalitySelectorProps {
  municipalityID?: number;
  onMunicipalitySectionChange: (municipalityID: number) => void;
}

export const MunicipalitySelector = ({ municipalityID, onMunicipalitySectionChange }: MunicipalitySelectorProps) => {
  const { data } = useLoadData<ApiResponse<any>>(municipalityApiKeyStore.getMunicipalities());

  const handleSelectChange = (event: any) => {
    onMunicipalitySectionChange(event.target.value);
  };

  return (
    <Grid item>
      <FormControl fullWidth style={{ marginBottom: '8px' }}>
        <InputLabel size="small" id="demo-simple-select-label">
        Municipality
        </InputLabel>
        <Select
          style={{ width: '200px' }}
          size="small"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={municipalityID}
          label="Mapping Type"
          onChange={handleSelectChange}
        >
          {data &&
            data.data.map((item: any) => (
              <MenuItem key={`${item.municipalityCode}-${item.municipalityID}`} value={item.municipalityID}>
                {item.muncipalityName}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Grid>
  );
};
